import "./App.css";
import "./custom.css";
import "react-quill/dist/quill.snow.css";
import "react-lazy-load-image-component/src/effects/blur.css";
// import { ModalProvider } from "react-modal-hook";
import RouterComponent from "router/index";
import React from "react";
import { ENV } from "configs/env";
import { useLanguages } from "redux/modules/languages/hook";

import { useLoadScript } from "@react-google-maps/api";
import ReactGA from "react-ga4";

import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/ar';
import 'moment/locale/hi';
import 'moment/locale/bn';
import 'moment/locale/ur';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';

const libraries = ["places"];

// Initialize ONCE outside the component — not inside useEffect
ReactGA.initialize(process.env.REACT_APP_GA_ID, {
  gtagOptions: {
    debug_mode: true, // Enables GA DebugView in Google Analytics
  }
});

function App() {
  const { getLanguages } = useLanguages();
  useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

//   React.useEffect(() => {
//     // Send pageview with a custom path
//     ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
// }, [])
  React.useEffect(() => {
    console.log("Initializing GA...");
    console.log("GA initialized, window.gtag:", typeof window.gtag); // should print "function"
    // console.log("GA instance:", ReactGA._currentMeasurementId); // should print your ID
    // console.log("dataLayer:", window.dataLayer);   // should show array with events
    // ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
    // console.log("ReactGA imported:", ReactGA);

    console.log("Pageview sent!");
  }, []);

  React.useEffect(()=>{
    //add eruda for debugging mobile in staging
    if(ENV === 'staging'){
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/eruda';
      script.onload = () => {
        window.eruda.init();
      };
      document.body.appendChild(script);
    }

    getLanguages();
    locationIP();
  },[])
  const locationIP = async()=>{
    try{
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        console.log(data.country)
        // "MMMM D YYYY" - USA format "D MMMM YYYY" - international format
        if(data.country === 'US'){
          localStorage.setItem('dateFormat', 'MMMM D YYYY');
        }else{
          localStorage.setItem('dateFormat', 'D MMMM YYYY');
        }
    }catch(e){
      console.log("Errror : " + e);
    }
  }
  return (
    /**
     * calling modal provider here causes milestone modal to crash 
     * because useLocation Hook cannot access current route
     */
    // <ModalProvider>
      <div className="App">
        <RouterComponent />
      </div>
    // </ModalProvider>
  );
}

export default App;
